(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tt/assets/javascripts/components/matchlist.js') >= 0) return;  svs.modules.push('/modules/tt/assets/javascripts/components/matchlist.js');
"use strict";


const _svs$tt$components = svs.tt.components,
  TipsenTable = _svs$tt$components.TipsenTable,
  BombenTable = _svs$tt$components.BombenTable,
  CopyRow = _svs$tt$components.CopyRow;
const shouldShowCopyRow = productSetting => {
  const name = (productSetting && productSetting.productName || '').toLowerCase();
  return name === 'topptipset' || name === 'powerplay' || name === 'fullträff';
};
const getToCouponURL = (productSetting, draw) => {
  if (!productSetting || !draw) {
    return null;
  }
  const baseUrl = window.location.origin;
  const productUrl = svs.core.detect.feature('ft-nova-powerplay') ? productSetting.urlNameNova : productSetting.urlName;
  return "".concat(baseUrl).concat(productUrl, "/?draw=").concat(draw.drawNumber);
};
const Matchlist = _ref => {
  let productSetting = _ref.productSetting,
    draws = _ref.draws,
    isVisible = _ref.isVisible;
  const template = productSetting.productTemplateName;
  const ownRowsCopy = shouldShowCopyRow(productSetting);
  const Table = template === 'bomben' ? BombenTable : TipsenTable;
  const labelPrefix = template === 'bomben' ? 'Aktuella omgångar ' : 'Aktuella omgångar ';
  return React.createElement("div", {
    className: "tt-matchlist"
  }, React.createElement("h2", {
    className: "f-800 f-prominent",
    id: "main-heading"
  }, labelPrefix, React.createElement("span", {
    className: "f-capitalize"
  }, productSetting.productName)), (!draws || draws.length === 0) && React.createElement("p", {
    className: "margin-bottom-2"
  }, "Just nu finns det inga \xF6ppna omg\xE5ngar f\xF6r detta spel. V\xE4nligen \xE5terkom senare."), draws.filter(draw => isVisible(draw.sport)).map(draw => React.createElement(React.Fragment, {
    key: "".concat(draw.productName || productSetting.productType, "-").concat(draw.drawNumber)
  }, React.createElement("h3", {
    className: "tt-matchlist-round-info margin-top-2 margin-bottom-1 f-600"
  }, React.createElement("span", {
    className: "f-prominent f-bold padding-right"
  }, template === 'bomben' ? draw.description : draw.drawComment, template === 'bomben' && draw.sport && draw.sport.name ? " - ".concat(draw.sport.name) : ''), React.createElement("span", null, " Omg\xE5ngsnummer: ".concat(draw.drawNumber)), React.createElement("a", {
    href: getToCouponURL(productSetting, draw),
    rel: "noopener noreferrer",
    target: "_blank"
  }, "Till Kupongen")), React.createElement(Table, {
    draw: draw
  }), ownRowsCopy && draw.copyValue ? React.createElement(CopyRow, {
    copyValue: draw.copyValue
  }) : null)));
};
setGlobal('svs.tt.components.Matchlist', Matchlist);

 })(window);